import { Divider, NavbarItem } from '@heroui/react';
import { NavLink } from 'react-router-dom';
import type { LinkItemParams } from '../models/navbar.model';

/**
 * Elemento de navegación individual para el menú desktop
 * Renderiza un link con animación hover y subrayado dinámico
 *
 * @param {LinkItemParams} props - Propiedades del componente
 * @param {NavbarLinkProps} props.item - Datos del item de navegación (label, path, key)
 */
const NavbarLinkItem = ({ item }: LinkItemParams) => {
  return (
    <NavbarItem className="flex flex-col gap-2 mt-1 hover:scale-105 duration-300 group">
      <NavLink to={item.path || '#'} className="isActive__item-link">
        {item.label}
      </NavLink>
      <Divider className="self-center w-0 group-hover:w-[100%] h-[.20rem] bg-secondary-white opacity-80 duration-300 rounded-full" />
    </NavbarItem>
  );
};

export default NavbarLinkItem;
